import { Route } from "react-router";
import { ChartBarIcon } from "components/Icons";

import Dash from "pages/Chart/DashChart";
// import Dash from "../apps/Dash/ScreenDash";
import HotelDash from "apps/Dash/views/HotelDash";
import SalesDash from "apps/Dash/views/SalesDash";
import RestaurantDash from "apps/Dash/views/RestaurantDash";

import apps from "./apps";
import proxy from "api/proxy";

function makeRoute(modelApp) {
  const { app_name, kind } = modelApp;
  if (!apps[app_name]) {
    return [null, null];
  }

  const { Component, Icon, addPath, children } = apps[app_name];

  let path = app_name;
  if (kind === "external") {
    path = `${app_name}/${addPath ?? ""}`;
  }
  const route = (
    <Route
      key={app_name}
      path={path}
      element={<Component key={app_name} config={modelApp} />}
      childrens={children}
    />
  );
  let menu;
  if (kind === "internal") {
    menu = {
      name: app_name,
      icon: Icon,
      path: `/dash/${path}`,
      children: children,
    };
  }
  return [route, menu];
}

async function getRoutes(session) {
  const dom = [["user", "=", session.user]];
  const fields = [
    "user",
    "apps.app_name",
    "apps.kind",
    "apps.active",
    "apps.origin.id",
    "reports",
  ];

  const { data: records } = await proxy.search("dash.access", dom, fields);
  const routesDash = [];
  const routesApps = [];
  const menus = [];
  if (records?.length > 0) {
    const recs = records[0];
    const accReports = recs.reports;
    // if (accReports) {
    //   const app_name = "charts";
    //   const routeChart = (
    //     <Route path={app_name} element={<Dash accReports={accReports} />}>
    //       <Route
    //         path="hotels"
    //         element={<HotelDash accReports={accReports} />}
    //       />
    //     </Route>
    //   );
    //   routesDash.push(routeChart);
    //   const menuCharts = {
    //     name: app_name,
    //     icon: ChartBarIcon,
    //     path: `/dash/${app_name}`,
    //   };
    //   menus.push(menuCharts);
    // }
    if (accReports) {
      const app_name = "charts";

      routesDash.push(
        <Route
          key="charts"
          path={app_name}
          element={<Dash accReports={accReports} />}
        />,
      );

      routesDash.push(
        <Route
          key="charts-hotels"
          path="charts/hotels"
          element={<HotelDash accReports={accReports} />}
        />,
      );

      routesDash.push(
        <Route
          key="charts-restaurants"
          path="charts/restaurant"
          element={<RestaurantDash accReports={accReports} />}
        />,
      );

      routesDash.push(
        <Route
          key="charts-sales"
          path="charts/sales"
          element={<SalesDash accReports={accReports} />}
        />,
      );

      menus.push({
        name: app_name,
        icon: ChartBarIcon,
        path: `/dash/${app_name}`,
      });
    }

    const apps = recs["apps."];
    for (const app of apps) {
      if (!app.active) {
        continue;
      }
      const config = null;
      const [route, menu] = makeRoute(app, config);
      if (!route) {
        continue;
      }
      if (app.kind === "external") {
        routesApps.push(route);
      } else {
        routesDash.push(route);
        menus.push(menu);
        if (route.props?.childrens?.length > 0) {
          route.props.childrens.forEach((child) => {
            const ChildComponent = child.Component;
            const parentConfig = route.props.element.props?.config || {};

            routesDash.push(
              <Route
                key={child.key}
                path={`${route.props.path}/${child.key}`}
                element={
                  <ChildComponent
                    key={child.key}
                    config={{
                      ...parentConfig,
                      app_name: child.key,
                    }}
                  />
                }
              />,
            );
          });
        }
      }
    }
  }
  return { menus, routesDash, routesApps };
}

export default getRoutes;
